import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { useNewLoginContext } from './NewLoginContext';
import NewLoginContent from './Content';

const styles = () => ({
  root: {},
});

const NewLoginContainer = ({
  className,
  classes,
}) => {
  const {
    isInitializing,
    initializingError,
  } = useNewLoginContext();

  return (
    <FullScreenDataContainer
      className={classes.container}
      component={NewLoginContent}
      componentProps={{
        className: classNames(classes.root, className),
      }}
      loading={isInitializing}
      loadingError={initializingError}
    />
  );
};

NewLoginContainer.defaultProps = {
  className: '',
};

NewLoginContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewLoginContainer);
